// PatientData Model
import { Model } from '@vuex-orm/core'

export default class PatientEmrPtDxDataList extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'PatientEmrPtDxDataLists' 

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      id : this.attr(null),
      pt_dx_id : this.attr(null),
      hn : this.attr(null),
      vn : this.attr(null),
      pt_indicators_id : this.attr(null),
      pt_indicators_name : this.attr(null),
      add_status : this.attr(null),
      delete_status : this.attr(null),
    }
  }
}

